<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="项目名称" prop="packageItemName">
        <el-input v-model="formInline.packageItemName" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset(searchFormRef)">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-box">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="packageItemId" label="项目编号" align="center" />
      <el-table-column prop="packageItemName" label="项目名称" align="center" />
      <el-table-column prop="extend1" label="项目描述" align="center" />

      <el-table-column label="操作" align="center" width="120">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editFn(scope.row)">修改描述</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
      :page-sizes="[10, 50, 100, 200]" :small="small" :background="background"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
  <el-dialog v-model="dialogFormVisible" append-to-body :close-on-click-modal="false" title="修改项目描述" width="500">
    <el-form :model="form" label-width="100px">
      <el-form-item label="项目描述">
        <el-input v-model="form.extend1" placeholder="请输入项目描述"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="comboItemInfoConfirm">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { InfoFilled, ArrowRightBold, ArrowDownBold, Check } from "@element-plus/icons-vue";
import service from "@/http/request.js";
const tableData = ref([]);

const formInline = reactive({
  packageItemName: "",
});
const searchFormRef = ref();
const onSubmit = () => {
  _comboItemList();
};
const onReset = (formEl) => {
  formEl.resetFields();
  pageSize.value = 10;
  currentPage.value = 1;
  _comboItemList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
  pageSize.value = val;
  _comboItemList();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  _comboItemList();
};
const _comboItemList = () => {
  service.post('/health/web/healthPackageItem/page', {
    pageSize: pageSize.value || null,
    pageNo: currentPage.value || null,
    ...formInline
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        tableData.value = data.data.data.records
        total.value = data.data.data.total
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};

let dialogFormVisible = ref(false)
const form = reactive({
  extend1: "",
});
const editFn = (row) => {
  form.id = row.id
  form.packageItemId = row.packageItemId
  form.extend1 = row.extend1
  dialogFormVisible.value = true
}
const comboItemInfoConfirm = () => {
  service.post('/health/web/healthPackageItem/update', {
    ...form
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        ElMessage({
          message: "修改成功",
          type: "success",
        });
        dialogFormVisible.value = false
        _comboItemList();
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
}
onMounted(() => {
  _comboItemList();
});

const handleToggle = (row) => {
  row.expanded = !row.expanded;
};
</script>
<style scoped lang="scss">
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}
</style>
